import React from "react";
import { WithClassName } from "./footer";
import mastercard from "../../../images/icons/mastercard.png";
import visa from "../../../images/icons/visa.png";
import paypal from "../../../images/icons/paypal.png";
import gpay from "../../../images/icons/google-pay.png";
import applepay from "../../../images/icons/apple-pay.png";
import klarna from "../../../images/icons/klarna.png";
import { __t } from "../../../utils/translate";

const images = [
    { logo: mastercard, name: 'mastercard payment logo', domains: ['any'] },
    { logo: visa, name: 'visa payment logo', domains: ['any'] },
    { logo: paypal, name: 'paypal payment logo', domains: ['any'] },
    { logo: gpay, name: 'google payment logo', domains: ['any'] },
    { logo: applepay, name: 'apple payment logo', domains: ['any'] },
    // TODO add domain to add klarna logo
    { logo: klarna, name: 'klarna payment logo', domains: ['http://localhost:8000', 'https://ortorex.dk'] },
];

const Payments: React.FC<WithClassName> = ({ className = "" }) => {
    const currentDomain = process.env.GATSBY_SITE_URL ? process.env.GATSBY_SITE_URL : '';

    const filteredImages = images.filter(image =>
        image.domains.includes('any') || image.domains.includes(currentDomain)
    );

    return (
        <div className={`${className} text-center md:text-left`}>
            <p className="text-base-16 text-light-gray uppercase mb-[10px] font-bold">
                {__t("Secure payments")}
            </p>
            <div className="flex gap-2 flex-wrap justify-center md:justify-start w-full max-w-[240px] md:max-w-[400px] mx-auto md:mx-0">
                {filteredImages.map((image, index) => {
                    return (
                        <img
                            className="h-[30px] w-[60px]"
                            src={image.logo}
                            alt={image.name}
                            loading="lazy"
                            key={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Payments;
